import React from "react";

const Loader = ({ customStyle="", width = "5px", height = "5px" }) => (
  <div className={`spinner ${customStyle}`} style={{ width, height, zIndex: 999 }}>
    <div className="double-bounce1" style={{ width, height }} />
    <div className="double-bounce2" style={{ width, height }} />
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/Loader.js